<template>
  <div>
    <!-- 附加服务 -->
    <el-dialog :title="$t('message.labelSetting')" :close-on-click-modal="false" :visible.sync="$parent.tagDialogVisible"
      width="450px" center>
      <!-- 标签类别 -->
      <div class="row">
        <div class="label">标签类别：</div>
        <div class="val">
          <el-select v-model="order_detail_tag.type" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- ASIN码： -->
      <div class="row">
        <div class="label">
          <!-- {{ order_detail_tag.type == 'FBA' ? 'ASIN码' : 'EMS-SKU' }}  -->
          标签编码：
        </div>
        <div class="val">
          <el-input v-model="order_detail_tag.no"></el-input>
        </div>
      </div>
      <!-- 标签编码： -->
      <div class="row">
        <div class="label">
          <!-- {{ order_detail_tag.type == 'FBA' ? '标签编码' : '商品名称' }} -->
          商品管理编码：
        </div>
        <div class="val">
          <el-input v-model="order_detail_tag.goods_no"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">

        <!--提交-->
        <el-button type="primary" @click="submitTag">{{ $t("message.submit") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    order_detail_tag: { type: Object }
  },
  data() {
    return {

      options: [{ value: 'FBA', }, { value: 'EMS-SKU', }]
    };
  },
  methods: {
    submitTag() {
      this.$parent.orderDetail[this.$parent.i].order_detail_tag[0] = this.order_detail_tag
      this.$parent.tagDialogVisible = false
      this.$forceUpdate()
    },
  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 10px;
  line-height: 40px;

  .label {
    width: 100px;
    margin-right: 10px;
  }

  .val {
    flex: 1;
  }
}
</style>